/**
 * Los 3 "Sigue leyendo" de cada articulo. FUENTE UNICA: lo consumen
 * `scripts/prerender-meta.js` (el HTML que ve Google sin JS) y
 * `src/pages/Blogpost.jsx` (lo que ve el lector). Estaban duplicados y el
 * 8-sep se vio que hay que tocar los dos a la vez o se desincronizan.
 *
 * QUE ARREGLA (medido el 8-sep sobre el HTML servido, no sobre los datos):
 * la version anterior cogia `.slice(0, 3)` de los candidatos **en el orden del
 * array**, sin ordenar por nada. Resultado: `wayo-vs-fitia` y `wayo-vs-yazio`
 * -1 clic cada una en 16 meses- eran las DOS paginas mas enlazadas del sitio
 * con 40 enlaces cada una, y solo 22 de 77 articulos recibian algun enlace
 * interno. Los otros 55 eran huerfanos: se rastrean menos y posicionan peor.
 *
 * Ahora se ordena por relevancia real (etiquetas en comun, luego fecha) y
 * ninguna pagina puede salir mas de TOPE veces. Con TOPE=4: 71 de 77 reciben
 * enlaces y la mas enlazada tiene 4. El tope no es cosmetica: es lo que impide
 * que una sola pagina vuelva a acaparar el presupuesto de enlaces.
 */
import { SLUGS_RETIRADOS } from './slugsRetirados.js';

const TOPE_POR_PAGINA = 4;
const CUANTOS = 3;

function ordenarCandidatos(post, vivos) {
  const propias = new Set(post.tags || []);
  return vivos
    .filter(
      (p) =>
        p.id !== post.id &&
        (p.category === post.category ||
          (p.tags || []).some((t) => propias.has(t)))
    )
    .map((p) => ({ p, comunes: (p.tags || []).filter((t) => propias.has(t)).length }))
    .sort(
      (a, b) =>
        b.comunes - a.comunes ||
        String(b.p.date || '').localeCompare(String(a.p.date || '')) ||
        a.p.id - b.p.id
    )
    .map((x) => x.p);
}

// El reparto es global (el tope necesita saber cuantas veces lleva usada cada
// pagina), asi que se calcula de una vez para TODOS y se cachea. Es una funcion
// pura de la lista: el prerender y el navegador obtienen exactamente lo mismo.
let cache = null;

export function mapaRelacionados(todos) {
  if (cache && cache.todos === todos) return cache.mapa;

  const vivos = todos.filter((p) => !SLUGS_RETIRADOS[p.slug]);
  const usos = new Map();
  const mapa = new Map();

  for (const post of vivos) {
    const cand = ordenarCandidatos(post, vivos);
    const elegidos = [];
    // 1a vuelta: solo los que no han agotado el tope.
    for (const p of cand) {
      if (elegidos.length === CUANTOS) break;
      if ((usos.get(p.slug) || 0) < TOPE_POR_PAGINA) elegidos.push(p);
    }
    // 2a vuelta: si no se llegan a 3, se completa aunque pasen del tope. Mas
    // vale repetir que dejar un articulo sin salida.
    for (const p of cand) {
      if (elegidos.length === CUANTOS) break;
      if (!elegidos.includes(p)) elegidos.push(p);
    }
    for (const p of elegidos) usos.set(p.slug, (usos.get(p.slug) || 0) + 1);
    mapa.set(post.id, elegidos);
  }

  cache = { todos, mapa };
  return mapa;
}

export function relacionadosDe(post, todos) {
  return mapaRelacionados(todos).get(post.id) || [];
}
